import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ItemsList from "../ItemsList/ItemsList.jsx";
import ControlButtons from "../ControlButtons/ControlButtons.jsx";
import FilterComponent from "../FilterComponent/FilterComponent.jsx";
import { toggleButtonTheme as add } from "../../config/theme";
import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import moment from "moment";
import PromoCodeModal from "../Modal/PromoCodeModal.jsx";
import styles from "./AllItems.module.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";

import {
    ASC,
    DESC,
    SEARCH_FIELDS_FOR_STRING,
    STATE_DATE_FORMAT,
    REGEX_FOR_ALL_BLANKS,
    DEFAULT_GET_PARAMS_RATES_AND_SERVICES,
} from "../../lib/data";
import { getArrToFilter } from "../../lib/helperFuncs.jsx";

let maxVisibleItems;
const screenHeight = window.screen.height;
const ITEMS_TO_ADD = 4;

if (screenHeight < 576) {
    maxVisibleItems = 10;
} else if (screenHeight >= 576 && screenHeight < 768) {
    maxVisibleItems = 12;
} else if (screenHeight >= 768 && screenHeight < 1200) {
    maxVisibleItems = 14;
} else if (screenHeight >= 1200) {
    maxVisibleItems = 22;
}

const makeItemsToShow = (items, totalItemsNum) => {
    const itemsToShow = [...items];
    const maxdefaultItemsOnScreen =
        totalItemsNum >= maxVisibleItems
            ? maxVisibleItems
            : totalItemsNum.length;

    return itemsToShow.slice(0, maxdefaultItemsOnScreen);
};

const AllItems = (props) => {
    const location = useLocation();
    const { mainId } = useParams();
    const [items, setItems] = useState([]);
    const [itemsToShow, setitemsToShow] = useState([]);
    const [sortingOrder, setSortingOrder] = useState(
        props?.globalSearch?.search?.[getLastPathName(location)]?.sortOrder ||
            props.defaultSortOrder ||
            ASC,
    );
    const [sortField, setSortField] = useState(
        props?.globalSearch?.search?.[getLastPathName(location)]?.sortField ||
            props.defaultSortfield ||
            "id",
    );
    const [promoCodesModalOpen, setPromoCodesModalOpen] = useState(false);
    const handleOpenPromoCodes = () => {
        setPromoCodesModalOpen(true);
    };

    const handleClosePromoCodes = () => {
        setPromoCodesModalOpen(false);
    };

    const scrollFn = (item, itemId) => {
        if (!item) return;
        const lastItemPosData = item.getBoundingClientRect();
        const widowClientData = window.scrollY + window.innerHeight;

        if (widowClientData > lastItemPosData.bottom) {
            const lastItemIndex = items.findIndex((item) => item.id === itemId);
            if (lastItemIndex >= 0 && lastItemIndex < items.length - 1) {
                const firstItemToAddIdx = lastItemIndex + 1;
                const itemsToAdd = items.slice(
                    firstItemToAddIdx,
                    firstItemToAddIdx + ITEMS_TO_ADD,
                );
                const updatedItems = itemsToShow.concat(itemsToAdd);

                return setitemsToShow(updatedItems);
            }
            return;
        }
    };

    useEffect(() => {
        if (props.initAction) {
            let params = mainId;
            if (props.params) {
                params = props.params;
            }
            if (props.getHotelsAction) {
                props.getHotelsAction();
            }

            if (
                !["promo", "rates"].includes(
                    getSearchEntity(location?.pathname),
                )
            ) {
                props.initAction(params);
            }
        }
    }, [mainId, props.initAction]);

    const sortItemsAction = (sortParams) => {
        const { sortField, sortOrder } = { ...sortParams };
        const itemsToSort = [...props.items];
        const sortedItems = sortBy(itemsToSort, sortField);
        let cutItems = makeItemsToShow(sortedItems, props.items.length);

        if (sortField === "active" || sortField === "value") {
            const fieldSet = new Set();
            itemsToSort.map((item) => fieldSet.add(item[sortField]));

            if (fieldSet.size === 1) {
                setSortingOrder(sortOrder);
                setSortField(sortField);
                setitemsToShow(cutItems);
                return setItems(sortedItems);
            }
        }

        if (sortOrder === DESC) {
            sortedItems.reverse();
            cutItems = makeItemsToShow(sortedItems, props.items.length);
        }

        setSortingOrder(sortOrder);
        setSortField(sortField);
        setitemsToShow(cutItems);
        setItems(sortedItems);
    };

    const searchItemsAction = (searchParams) => {
        if (
            isEmpty(searchParams) ||
            JSON.stringify(searchParams) ===
                JSON.stringify(DEFAULT_GET_PARAMS_RATES_AND_SERVICES)
        ) {
            const cutItems = makeItemsToShow(props.items, props.items.length);
            setItems(props.items);
            return setitemsToShow(cutItems);
        }

        let searchResults = [];
        let searchedWithString;
        let searchedWithDate;
        let searchedWithActive;
        let searchedWithHotels;

        for (const key of Object.keys(searchParams)) {
            if (SEARCH_FIELDS_FOR_STRING.includes(key)) {
                const searchKey = key === "login" ? "name" : key;
                const arrToFilter = getArrToFilter(
                    searchedWithString,
                    searchedWithDate,
                    searchedWithActive,
                    searchedWithHotels,
                    props.items,
                    searchResults,
                );

                searchResults = arrToFilter.filter((item) => {
                    const searchedVal = searchParams[key].toLowerCase();
                    const valueToSearchIn = item[searchKey]
                        ?.toLowerCase()
                        .replace(REGEX_FOR_ALL_BLANKS, "");

                    return valueToSearchIn?.includes(searchedVal);
                });

                searchedWithString = true;
            } else if (key.includes("date")) {
                const arrToFilter = getArrToFilter(
                    searchedWithString,
                    searchedWithDate,
                    searchedWithActive,
                    searchedWithHotels,
                    props.items,
                    searchResults,
                );

                const parsedParams = searchParams[key].split(":");
                const compareVal = parsedParams[0];
                const valToCompare = parsedParams[1];

                switch (compareVal) {
                    case "lt":
                        searchResults = arrToFilter.filter((item) => {
                            return moment(item[key]).isBefore(
                                moment(valToCompare, STATE_DATE_FORMAT),
                            );
                        });
                        break;
                    case "gt":
                        searchResults = arrToFilter.filter((item) =>
                            moment(item[key]).isAfter(
                                moment(valToCompare, STATE_DATE_FORMAT),
                            ),
                        );
                        break;
                    case "eq":
                        searchResults = arrToFilter.filter((item) =>
                            moment(item[key]).isSame(valToCompare),
                        );
                        break;
                    case "lteq":
                        searchResults = arrToFilter.filter((item) =>
                            moment(item[key]).isSameOrBefore(
                                moment(valToCompare, STATE_DATE_FORMAT),
                            ),
                        );
                        break;
                }
                searchedWithDate = true;
            } else if (
                key === "active" ||
                key === "hidden" ||
                key === "inherited"
            ) {
                const arrToFilter = getArrToFilter(
                    searchedWithString,
                    searchedWithDate,
                    searchedWithActive,
                    searchedWithHotels,
                    props.items,
                    searchResults,
                );

                searchResults = arrToFilter.filter(
                    (item) => item[key] == searchParams[key],
                );

                searchedWithActive = true;
            } else if (key === "hotels") {
                const arrToFilter = getArrToFilter(
                    searchedWithString,
                    searchedWithDate,
                    searchedWithActive,
                    searchedWithHotels,
                    props.items,
                    searchResults,
                );

                searchResults = arrToFilter.filter((item) => {
                    if (item[key].length > 0) {
                        for (const hotel of item[key]) {
                            if (
                                hotel.name
                                    .trim()
                                    .toLowerCase()
                                    .replace(REGEX_FOR_ALL_BLANKS, "") ===
                                searchParams[key].toLowerCase()
                            ) {
                                return item;
                            }
                        }
                    }
                });
                searchedWithHotels = true;
            }
        }

        const cutItems = makeItemsToShow(searchResults, props.items.length);

        setitemsToShow(cutItems);
        setItems(searchResults);
    };

    useEffect(() => {
        sortItemsAction({ sortField: sortField, sortOrder: sortingOrder });
    }, [props.items]);

    let itemsList = <Typography variant={"body1"}>Нет записей </Typography>;

    const handleMassAction = async (
        selectedIds,
        action,
        partition,
        setSelectedIds,
    ) => {
        if (action === 3) {
            const confirmed = window.confirm(
                "Вы уверены, что хотите выполнить массовое удаление?",
            );
            if (!confirmed) return;
        }

        try {
            const response = await axios.post("/manager/data/mass_action", {
                selectedIds,
                action,
                partition,
            });

            alert(response.data.message);

            const button = Array.from(document.querySelectorAll("button")).find(
                (btn) => btn.innerText.trim() === "Поиск",
            );

            if (button) {
                button.click();
                if (partition === "service") {
                    props.initAction();
                }
                setSelectedIds([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    if (props.items && props.items.length > 0) {
        itemsList = (
            <ItemsList
                items={itemsToShow}
                columns={props.columns}
                fields={props.fields}
                moreParams={props.params}
                sortField={
                    props?.globalSearch?.search?.[getLastPathName(location)]
                        ?.sortField || sortField
                }
                sortOrder={
                    props?.globalSearch?.search?.[getLastPathName(location)]
                        ?.sortOrder || sortingOrder
                }
                setSortField={setSortField}
                setSortOrder={setSortingOrder}
                sortAction={sortItemsAction}
                toggleAction={props.toggleAction}
                viewAction={props.viewAction}
                copyObject={props.copyObject}
                editAction={props.editAction}
                selectHotelAction={props.setHotel}
                setDirectLink={props.setDirectLink}
                loadExcelAction={props.loadExcelAction}
                removeAction={
                    mainId
                        ? (id) => props.removeAction(mainId, id)
                        : props.removeAction
                }
                listButtons={props.listButtons}
                updateParticularItem={props.updateParticularItem}
                scrollFn={scrollFn}
                needViewCopyButton={props.needViewCopyButton}
                thisMessageLogs={props?.thisMessageLogs}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
                thisPurchasedServices={props?.thisPurchasedServices}
                thisManteraExport={props?.thisManteraExport}
                hotelId={props.hotelId}
                partition={props?.partition}
                handleMassAction={handleMassAction}
                thisRefund={props?.thisRefund}
            />
        );
    }

    const controlButtons = props.addRoute
        ? [
              {
                  type: add,
                  icon: <AddCircleIcon />,
                  caption: "Создать",
                  link: () => props.addRoute(mainId),
              },
          ]
        : [];

    if (props.controlButtons && Object.keys(props.controlButtons).length > 0) {
        controlButtons.push(props.controlButtons);
    }

    const downloadExcel = () => {
        if (props.items?.length < 1) {
            return;
        }
        const headers = [
            "Номер заявки",
            "Название услуги",
            "Стоимость",
            "Пожелание гостя",
            "Статус",
            "ФИО",
            "Телефон покупателя",
        ];

        const worksheetData = [
            headers,
            ...props.items.map((item) => [
                item.reservation_number,
                item.service_id,
                item.price,
                item.comment,
                item.status,
                item.reservation.guest.first_name +
                    " " +
                    item.reservation.guest.last_name,
                item.reservation.guest?.phone,
            ]),
        ];

        const autoFitColumns = (data) => {
            const maxLengths = data[0].map((_, colIndex) =>
                Math.max(
                    ...data.map((row) => String(row[colIndex] || "").length),
                ),
            );
            return maxLengths.map((length) => ({ width: length + 2 }));
        };

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        worksheet["!cols"] = autoFitColumns(worksheetData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ExportedData");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });
        saveAs(blob, "Reservations_services.xlsx");
    };

    return (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {!props?.thisMessageLogs && props.title}
                    {!props?.thisMessageLogs && (
                        <ControlButtons items={controlButtons} />
                    )}
                    {props?.thisMessageLogs && (
                        <div className={styles.title__container}>
                            {props.title}
                            <div className={styles.button__container}>
                                <Button
                                    className={styles.grey__button}
                                    variant="contained"
                                    color="primary"
                                    onClick={props.handleUpdateHRS}
                                >
                                    Обновить список
                                    <span className={styles.icon__right}>
                                        {updateIcon}
                                    </span>
                                </Button>
                                <Button
                                    className={styles.black__button}
                                    variant="contained"
                                    color="primary"
                                    onClick={props.sendDataHRS}
                                >
                                    Отправить данные
                                </Button>
                            </div>
                        </div>
                    )}
                    {props?.thisPurchasedServices && (
                        <div style={{ marginTop: "25px" }}>
                            <Button
                                onClick={() => downloadExcel(props?.items)}
                                className={styles.black__button}
                                variant="contained"
                                color="primary"
                            >
                                Скачать Excel
                            </Button>
                        </div>
                    )}
                </Typography>
                {props?.thisPromo && (
                    <>
                        <Button
                            style={{ marginTop: "10px" }}
                            variant="contained"
                            color="primary"
                            onClick={handleOpenPromoCodes}
                        >
                            Показать промокоды из других отелей
                        </Button>
                        <PromoCodeModal
                            open={promoCodesModalOpen}
                            onClose={handleClosePromoCodes}
                            hotelId={props.hotelId}
                            reload={props.initAction}
                        />
                    </>
                )}
            </Box>
            {props?.items && (
                <FilterComponent
                    pathname={location.pathname}
                    initSearch={props.paramsChangeHandler}
                    searchItemsAction={searchItemsAction}
                    hotelsData={props.hotelsData}
                    getParams={props.getParams}
                    globalSearch={props.globalSearch}
                    updateGlobalSearch={props.updateGlobalSearch}
                    interfaces={props.interfaces}
                    thisMessageLogs={props?.thisMessageLogs}
                    serviceCategories={props?.serviceCategories}
                />
            )}
            <Box mt={4}>
                {props.loading ? <LinearProgress mt={3} /> : itemsList}
            </Box>
        </Paper>
    );
};

AllItems.defaultProps = {
    loading: true,
    items: [],
    columns: { id: "Id", name: "Наименование", active: "Активен" },
};

AllItems.propTypes = {
    params: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fields: PropTypes.object,
    columns: PropTypes.object,
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    initAction: PropTypes.func,
    viewAction: PropTypes.func,
    editAction: PropTypes.func,
    toggleAction: PropTypes.func,
    removeAction: PropTypes.func,
    loadExcelAction: PropTypes.func,
    setHotel: PropTypes.func,
    addRoute: PropTypes.func,
    listButtons: PropTypes.array,
    controlButtons: PropTypes.object,
    updateParticularItem: PropTypes.func,
    defaultSortfield: PropTypes.string,
    getHotelsAction: PropTypes.func,
    hotelsData: PropTypes.array,
};

export default AllItems;

const updateIcon = (
    <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18 4L14 8H17C17 11.31 14.31 14 11 14C9.99 14 9.03 13.75 8.2 13.3L6.74 14.76C7.97 15.54 9.43 16 11 16C15.42 16 19 12.42 19 8H22L18 4ZM5 8C5 4.69 7.69 2 11 2C12.01 2 12.97 2.25 13.8 2.7L15.26 1.24C14.03 0.46 12.57 0 11 0C6.58 0 3 3.58 3 8H0L4 12L8 8H5Z"
            fill="#1F1F1F"
        />
    </svg>
);

const getLastPathName = (location) => {
    const pathname = location?.pathname;
    if (pathname) {
        const pathParts = pathname?.split("/");
        const name = pathParts?.[pathParts?.length - 1];
        if (name) {
            return name;
        }
    }
    return null;
};

const getSearchEntity = (path) => {
    const pathArr = path.split("/");
    let entity = pathArr[pathArr.length - 1];
    if (pathArr.includes("users") && pathArr.length > 2) {
        entity = "operators";
    }
    return entity;
};
